function getResourceIdFromHref(href) {
  const source = href.split('/');
  return source[source.length - 1];
}

export default function networkConnection(network) {
  return function normalizeBYNetwork(rawData) {
    return {
      // eslint-disable-next-line no-underscore-dangle
      id: getResourceIdFromHref(rawData._links.self.href),
      title: rawData.label,
      hash: rawData.hash,
      network,
      socialiveAvailable: true,
      enabled: true,
    };
  };
}
